import { Navigate, useLocation } from 'react-router-dom'
import { hasGuestAgreement } from '../engine/guestSession'
import { useAuth } from '../contexts/AuthContext'

const Spinner = () => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', backgroundColor: '#0F2A4A'
  }}>
    <div style={{
      width: 48, height: 48, borderRadius: '50%',
      border: '4px solid #D4AF37', borderTopColor: 'transparent',
      animation: 'spin 0.8s linear infinite'
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
)

const ProtectedRoute = ({ children, adminOnly = false, allowGuest = false }) => {
  const { user, loading, profileLoading, userRole, hasAcceptedAgreement } = useAuth()
  const location = useLocation()

  if (loading || (user && profileLoading)) return <Spinner />
  if (!user && allowGuest && !adminOnly) {
    return hasGuestAgreement() ? children : <Navigate to="/beta-agreement?guest=1" replace state={{ from: location.pathname }} />
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (!user.email_confirmed_at) return <Navigate to="/verify-email" replace />
  if (!hasAcceptedAgreement) return <Navigate to="/beta-agreement" replace state={{ from: location.pathname }} />
  if (adminOnly && userRole !== 'admin') return <Navigate to="/" replace />

  return children
}

export default ProtectedRoute
